export * from '@primeuix/themes/material/contextmenu';
export { default } from '@primeuix/themes/material/contextmenu';
